import "../css/homepage.css";

const SearchBar = ({ value, onChange, onSearch }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value.trim()) {
      onSearch(value);
    }
  };

  return (
    <div className="searchbar">
      <input
        type="search"
        placeholder="Search River system, Town, or Facility"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="searchbar-input"
      />

      <button
        className="searchbar-button"
        onClick={() => value.trim() && onSearch(value)}
      >
        🔍
      </button>
    </div>
  );
};

export default SearchBar;
